var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ul',{staticClass:"hiq-operational-disturbances__hit-list"},_vm._l((_vm.hits),function(hit){return _c('Hit',{key:hit.id,ref:"hit",refInFor:true,attrs:{"hit":hit}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }